const commonAndMisc = {
  errorMessage404: "Naku! Wala ang pahinang hinahanap mo", // translated 
  errorContentUnavailable:
    "Naku! Wala ang nilalamang hinahanap mo. Mangyaring makipag-ugnayan sa amin tungkol sa problema.", // translated 
  backToHome: "Balik sa Bahay", // translated 
  information: "Impormasyon", // translated 
  additionalInformation: "Karagdagang Impormasyon", // translated 
  destinationPlaceholder: "Saan ka pupunta", // translated 
  aboutUs: "Tungkol sa Amin", // translated 
  pleaseWait: "Mangyaring maghintay...", // translated 
  featuredHotels: "Mga Itinatampok na Hotel", // translated 
  topPackages: "Mga Nangungunang Pakete", // translated 
  topTours: "Mga Nangungunang Paglilibot", // translated 
  traveller: "Manlalakbay", // translated 
  reviews: "Mga Review", // translated 
  home: "Tahanan", // translated 
  packages: "Mga Pakete", // translated 
  experiences: "Mga Karanasan", // translated 
  close: "Isara", // translated 
  loadingMessage: "Mangyaring maghintay habang hinahanap namin ang pinakamagandang presyo na magagamit", // translated 
  loadingMessageTheHotelCo:
    "Mangyaring maghintay habang hinahanap namin ang pinakamagandang presyo na magagamit", // translated 
  loadingMessageSearchStrip:
    "Mangyaring maghintay habang hinahanap namin ang pinakamagandang presyo na available...", // translated 

  stillSearchingHotels:
    "Still searching — {{priced}} of {{discovered}} hotels priced",
  hotelsProgressCount: "Found {{priced}} of {{discovered}} hotels",
  searchingSuppliers: "Checking {{suppliers}}",
  topCountriesToVisit: "Mga Nangungunang Bansa na Dapat Bisitahin", // translated 
  profile: "Profile", // translated 
  reservations: "Mga reserbasyon", // translated 
  myBookings: "Mga Booking Ko", // translated 
  address: "Tirahan", // translated 
  firstName: "Pangalan", // translated 
  lastName: "Apelyido", // translated 
  email: "I-email", // translated 
  login: "Mag-login", // translated 
  logout: "Mag-logout", // translated 
  myProfile: "Aking Profile", // translated 
  myAccount: "Aking Account", // translated 
  myPoints: "Aking mga Puntos", // translated 
  myQuotations: "Aking Mga Sipi", // translated 
  myChatRooms: "Aking mga Chat", // translated 
  chatRoomsListEmpty: "Wala kang mga chat room para sa account na ito.", // translated 
  chatRoomsOpen: "Bukas", // translated 
  chatRoomsLastActivity: "Huling aktibidad", // translated 
  chatRoomsUnread: "Hindi pa nababasa", // translated 
  chatRoomsBadgeQuotation: "Sipi", // translated 
  chatRoomsBadgeTripOffer: "Alok ng biyahe", // translated 
  chatRoomsOpenQuotationAria: "Buksan ang chat para sa sipi: {{name}}", // translated 
  chatRoomsOpenTripOfferAria: "Chat para sa alok na bukas na biyahe: {{name}}", // translated 
  chatRoomsOpenGenericAria: "Buksan ang chat: {{name}}", // translated 
  quotationChatInvalidLink:
    "Hindi wastong link ng chat. Magbukas ng chat mula sa iyong profile o listahan ng mga sipi, o gumamit ng eksaktong isa sa room_code o room_uid.", // translated 
  quotationChatNoTripDetails: "Hindi available ang mga detalye ng biyahe para sa chat na ito.", // translated 
  chat: "Makipag-chat", // translated 
  verified: "Na-verify", // translated 
  unverified: "Hindi na-verify", // translated 
  selectLanguage: "Pumili ng wika", // translated 
  selectCurrency: "Pumili ng pera", // translated 
  upgrade: "Pag-upgrade", // translated 
  membership: "Pagiging Miyembro", // translated 
  travelTrust: "Tiwala sa Paglalakbay", // translated 
  signInUp: "Mag-sign In/Up", // translated 
  worldwideHotelsAndResortsAtAmazingWholesaleRates:
    "mga hotel at resort sa buong mundo sa kamangha-manghang mga presyong pakyawan", // translated 
  dashboard: "Dashboard", // translated 
  pricing: "Pagpepresyo", // translated 
  refundable: "Maaring ibalik", // translated 
  cars: "Mga Kotse", // translated 
  cruises: "Mga Cruise", // translated 
  view: "Tingnan", // translated 
  price: "Presyo", // translated 
  totalPrice: "Kabuuang presyo", // translated 
  filterRoomName: "I-filter ang pangalan ng kwarto", // translated 
  get: "Kunin", // translated 
  guestInformationValidation: "Pagpapatunay ng Impormasyon ng Bisita", // translated 
  reservation: "Reserbasyon", // translated 
  checkIn: "Mag-check in", // translated 
  checkOut: "Mag-check Out", // translated 
  paymentInitiattionErroeMessage:
    "Hindi namin masimulan ang proseso ng iyong pagbabayad. Humihingi kami ng paumanhin sa abala.", // translated 
  warning: "Babala", // translated 
  couldNotFindPriceForDateWarning:
    "Hindi kami makahanap ng presyo para sa petsang ito. Pakisubukang muli para sa ibang petsa.", // translated 
  searchFormValidationError: "Error sa Pagpapatunay ng Form ng Paghahanap", // translated 
  pleaseSelectValidDateFirst: "Pumili muna ng wastong petsa", // translated 
  searchError: "Error sa Paghahanap", // translated 
  priceSearchInitiationError:
    "Hindi namin masimulan ang proseso ng paghahanap ng presyo. Pakisubukang muli mamaya. Humihingi kami ng paumanhin sa abala.", // translated 
  searchWarning: "Babala sa Paghahanap", // translated 
  couldNotFindPriceAndOrAvailability:
    "Hindi namin mahanap ang presyo at/o availability para sa iyong kahilingan. Humihingi kami ng paumanhin sa abala.", // translated 
  joinNow: "Sumali Ngayon", // translated 
  signIn: "Mag-sign In", // translated 
  searchNow: "Maghanap ngayon", // translated 
  bookingFailed: "Nabigo ang pag-book", // translated 
  sorryForTheInconvenience: "Humihingi kami ng paumanhin sa abala", // translated 
  contactUsToAssistWithYourBooking:
    "Mangyaring makipag-ugnayan sa amin upang tumulong sa iyong booking. Humihingi kami ng paumanhin sa abala.", // translated 
  paymentFailedTryAgain: "Nabigo ang pagbabayad. Pakisubukang muli", // translated 
  quickLinks: "Mga Mabilisang Link", // translated 
  tours: "Mga Paglilibot", // translated 
  termsAndConditions: "Mga Tuntunin at Kundisyon", // translated 
  pleaseWaitWhileInitiatingPayment:
    "Mangyaring maghintay habang sinisimulan namin ang proseso ng iyong pagbabayad", // translated 
  back: "Balik", // translated 
  nextStep: "Susunod na Hakbang", // translated 
  book: "Libro", // translated 
  checkout: "Pag-checkout", // translated 
  specifyPickUpPoint: "Tukuyin ang punto ng iyong gustong pagkuha", // translated 
  pickupPoint: "Punto ng Pagsundo", // translated 
  optional: "opsyonal", // translated 
  provideImportantInfoForYourTravel:
    "Ipaalam sa amin ang anumang impormasyon na mahalaga sa iyong paglalakbay", // translated 
  remarks: "Mga Paalala", // translated 
  travellerInformation: "Impormasyon ng Manlalakbay", // translated 
  bookingRemarks: "Mga Paalala sa Pag-book", // translated 
  bookingOverview: "Pangkalahatang-ideya ng Pag-book", // translated 
  paymentFailed: "Nabigo ang Pagbabayad", // translated 
  paymentSuccess: "Tagumpay sa Pagbabayad", // translated 
  at: "Sa", // At date // translated 
  on: "Naka-on", // on date // translated 
  person: "tao", // translated 
  cancellationPolicy: "Patakaran sa Pagkansela", // translated 
  From: "Mula sa", // translated 
  to: "Para sa", // translated 
  cancellationIs: "ang pagkansela ay", // translated 
  pickup: "Pagkuha", // translated 
  flights: "Mga Paglipad", // translated 
  Accommodation: "Akomodasyon", // translated 
  payAndBook: "Magbayad at Mag-book", // translated 
  onRequest: "Kapag hiniling", // translated 
  weAreFindingTheBestAvailableServices:
    "Hinahanap namin ang pinakamahusay na magagamit na mga serbisyo", // translated 
  withTheBestAvailablePrices: "gamit ang pinakamagandang presyong makukuha", // translated 
  inRealTime: "sa totoong oras", // translated 
  seconds: "segundo", // translated 
  thisProcessCanTakeUpToOneMinute: "Ang prosesong ito ay maaaring tumagal nang hanggang 1 minuto", // translated 
  pleaseDoNotRefreshThisPage: "Mangyaring huwag i-refresh ang pahinang ito", // translated 
  wellItSeemsItCanTakeBitLonger: "Aba... mukhang matatagalan pa ito nang kaunti", // translated 
  yourBrowserDoesNotSupportTheVideoTag:
    "Hindi sinusuportahan ng iyong browser ang tag ng video", // translated 
  bookingSuccess: "Tagumpay sa pag-book", // translated 
  bookingReference: "Sanggunian sa Pag-book", // translated 
  referenceCopied: "Nakopya ang sanggunian", // translated 
  shortlyYouReceiveEmailContainingInformationForYourReservation:
    "Maya-maya, makakatanggap ka ng email na naglalaman ng lahat ng kinakailangang impormasyon para sa iyong reserbasyon.", // translated 
  viewMore: "Tingnan ang higit pa", // translated 
  readMore: "Magbasa pa", // translated 
  customerSupport: "Suporta sa Kustomer", // translated 
  socialMedia: "Social Media", // translated 
  hours: "oras", // translated 
  hour: "oras", // translated 
  minutes: "minuto", // translated 
  minute: "minuto", // translated 
  memberId: "ID ng Miyembro", // translated 
  star: "Bituin", // translated 
  stars: "Mga Bituin", // translated 
  proceed: "Magpatuloy", // translated 
  clearAllFilters: "I-clear ang lahat ng filter", // translated 
  clearYourFilters: "Paki-clear ang iyong mga opsyon sa filter para makita ang mga resulta", // translated 
  noOptionsForSelectedFilters: "Walang available na opsyon para sa pagtutugma ng iyong mga filter", // translated 
  privacyPolicy: "Patakaran sa Pagkapribado", // translated 
  security: "Seguridad", // translated 
  nearby: "Malapit", // translated 
  distanceFromSelection: "Layo mula sa pagpili", // translated 
  km: "kilometro", // translated 
  restaurants: "Mga restawran", // translated 
  active: "Aktibo", // translated 
  visitSite: "Bisitahin ang site", // translated 
  score: "Iskor", // translated 
  applicationAvailable: "magagamit na aplikasyon", // translated 
  sendUsEmail: "Padalhan kami ng Email", // translated 
  sendUsYourRequest: "Ipadala sa amin ang iyong kahilingan", // translated 
  notAvailable: "Hindi Magagamit", // translated 
  found: "Natagpuan", // translated 
  progressAt: "Pag-unlad sa", // translated 
  currency: "Pera", // translated 
  sendUsRequest: "Ipadala sa amin ang iyong kahilingan", // translated 
  noReservationsForThisProduct: "Walang reserbasyon para sa produktong ito", // translated 
  noBookingsForThisProduct: "Walang booking para sa produktong ito", // translated 
  noReservationsOfThisProduct: "Walang reserbasyon para sa ganitong uri ng produkto", // translated 
  actions: "Mga Aksyon", // translated 
  save: "I-save", // translated 
  confirmed: "Nakumpirma", // translated 
  cancelled: "Kinansela", // translated 
  pending: "Nakabinbin", // translated 
  notConfirmed: "Hindi Nakumpirma", // translated 
  status: "Katayuan", // translated 
  reference: "Sanggunian", // translated 
  leadGuest: "Pangunahing Panauhin", // translated 
  sendVoucherEmail: "Ipadala ang Email ng Voucher", // translated 
  sendCancellationEmail: "Magpadala ng Email sa Pagkansela", // translated 
  downloadVoucher: "I-download ang Kupon", // translated 
  emailHasBeenSent: "Matagumpay na naipadala ang email", // translated 
  emailNotSentTryAgain: "Hindi naipadala ang email! Pakisubukang muli", // translated 
  titleIsRequired: "Kinakailangan ang pamagat", // translated 
  genderIsRequired: "Kinakailangan ang kasarian", // translated 
  firstNameMustContainAlphabetic:
    "Ang unang pangalan ay dapat maglaman lamang ng mga karakter na alpabeto", // translated 
  firstNameIsRequired: "Kinakailangan ang unang pangalan", // translated 
  lastNameIsRequired: "Kinakailangan ang apelyido", // translated 
  lastNameMustContainAlphabetic:
    "Ang apelyido ay dapat maglaman lamang ng mga alpabetikong karakter", // translated 
  phoneNumberInTheFormat: "Dapat nasa format na walang espasyo ang numero ng telepono", // translated 
  phoneNumberIsRequired: "Kinakailangan ang numero ng telepono", // translated 
  emailIsRequired: "Kinakailangan ang email", // translated 
  invalidEmail: "Hindi wastong email", // translated 
  addressIsRequired: "Kinakailangan ang address", // translated 
  cityIsRequired: "Kinakailangan ang lungsod", // translated 
  postalCodeIsRequired: "Kinakailangan ang postal code", // translated 
  countryIsRequired: "Kinakailangan ang bansa", // translated 
  yourReservationIsInProgress: "Ang iyong reserbasyon ay isinasagawa na", // translated 
  yourReservationHasBeenRegistered: "Narehistro na ang iyong reserbasyon", // translated 
  clickHere: "Mag-click dito", // translated 
  iHaveReadAgreeWithAbove: "Nabasa ko na at sumasang-ayon ako sa nasa itaas", // translated 
  pleaseCheckTheBox:
    "Lagyan ng tsek ang kahon sa ibaba upang ipahiwatig na nabasa at sumasang-ayon ka sa ibinigay na impormasyon bago magpatuloy sa susunod na hakbang.", // translated 
  pleaseAcceptProperty:
    "Pakilagyan ng tsek ang kahon sa itaas upang ipahiwatig na ang property na ibinu-book ay ang kailangan mo.", // translated 
  ourContactNumbersAre: "Ang aming mga numero ng kontak ay", // translated 
  operationalHours: "Mga Oras ng Operasyon", // translated 
  monday: "Lunes", // translated 
  tuesday: "Martes", // translated 
  wednesday: "Miyerkules", // translated 
  thursday: "Huwebes", // translated 
  friday: "Biyernes", // translated 
  saturday: "Sabado", // translated 
  sunday: "Linggo", // translated 
  monday_to_friday: "Lunes hanggang Biyernes", // translated 
  closed: "Sarado", // translated 
  topUpPoints: "Mga Punto ng Pag-top Up", // translated 
  gender: "Kasarian", // translated 
  nationality: "Nasyonalidad", // translated 
  amountIn: "Halaga na Pasok", // translated 
  amountOut: "Halagang Lalabas", // translated 
  maintenanceTitle: "Ang website ay nasa ilalim ng pagpapanatili", // translated 
  maintenanceDescription:
    "Nagsasagawa kami ng naka-iskedyul na pagpapanatili. Mangyaring bumalik muli sa lalong madaling panahon.", // translated 
  maintenanceCountdownLabel: "Tinatayang oras na natitira", // translated 
  maintenanceLogoAlt: "Logo ng website", // translated 
  maintenanceDays: "Mga Araw", // translated 
  maintenanceHours: "Mga Oras", // translated 
  maintenanceMinutes: "Minuto", // translated 
  maintenanceSeconds: "Segundo", // translated 
  maintenanceStatusBadge: "Naka-iskedyul na pagpapanatili", // translated 
  maintenanceRefresh: "I-refresh ang pahina", // translated 
  maintenanceExpired:
    "Dapat makumpleto ang maintenance sa lalong madaling panahon. Paki-refresh ang pahina.", // translated 
};


export default commonAndMisc;
